/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RosettaPublicKey,
    RosettaPublicKeyFromJSON,
    RosettaPublicKeyFromJSONTyped,
    RosettaPublicKeyToJSON,
    SigningPayload,
    SigningPayloadFromJSON,
    SigningPayloadFromJSONTyped,
    SigningPayloadToJSON,
} from './';

/**
 * Signature contains the payload that was signed, the public keys of the keypairs used to produce the signature, the signature (encoded in hex), and the SignatureType. PublicKey is often times not known during construction of the signing payloads but may be needed to combine signatures properly.
 * @export
 * @interface RosettaSignature
 */
export interface RosettaSignature {
    /**
     * 
     * @type {SigningPayload}
     * @memberof RosettaSignature
     */
    signing_payload: SigningPayload;
    /**
     * 
     * @type {RosettaPublicKey}
     * @memberof RosettaSignature
     */
    public_key: RosettaPublicKey;
    /**
     * SignatureType is the type of a cryptographic signature.
     * @type {string}
     * @memberof RosettaSignature
     */
    signature_type: RosettaSignatureSignatureTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RosettaSignature
     */
    hex_bytes: string;
}

/**
* @export
* @enum {string}
*/
export enum RosettaSignatureSignatureTypeEnum {
    ecdsa = 'ecdsa',
    ecdsa_recovery = 'ecdsa_recovery',
    ed25519 = 'ed25519',
    schnorr_1 = 'schnorr_1',
    schnorr_poseidon = 'schnorr_poseidon'
}

export function RosettaSignatureFromJSON(json: any): RosettaSignature {
    return RosettaSignatureFromJSONTyped(json, false);
}

export function RosettaSignatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): RosettaSignature {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signing_payload': SigningPayloadFromJSON(json['signing_payload']),
        'public_key': RosettaPublicKeyFromJSON(json['public_key']),
        'signature_type': json['signature_type'],
        'hex_bytes': json['hex_bytes'],
    };
}

export function RosettaSignatureToJSON(value?: RosettaSignature | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'signing_payload': SigningPayloadToJSON(value.signing_payload),
        'public_key': RosettaPublicKeyToJSON(value.public_key),
        'signature_type': value.signature_type,
        'hex_bytes': value.hex_bytes,
    };
}

